import { SaleModel } from 'api-hooks/sale/common';
import { AuthorizationRules } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import OtherIncomeList from 'legacy-modules/other-income/list';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useSalesOtherIncome(data: SaleModel) {
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const { t } = useTranslation();

  const status = data.status;
  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Refund:
        return false;
      default:
        return true;
    }
  }, [status]);

  const permission = AuthorizationRules.SalesGetOtherIncomes;

  const otherIncomePermission =
    isAllowed && can(permission) && data.transactionType !== 'tour';

  const onOtherIncome = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <OtherIncomeList type="Sale" data={data} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, data]);

  const otherIncomeAction: PopoverMenuType = {
    label: t('common:other_incomes'),
    onClick: onOtherIncome,
    isAllowed: otherIncomePermission,
    isError: false,
    key: `other-incomes-${data.id}`,
  };

  return {
    otherIncomeAction,
    otherIncomePermission,
    permission,
    onOtherIncome,
  };
}
